module.exports = __webpack_public_path__ + "img/jp_xhs_qrcode.4e084d2.jpg";